import React from 'react'
import './Button.css'

/**
 * 재사용 가능한 버튼 컴포넌트
 */
function Button({ 
  children, 
  onClick, 
  disabled = false, 
  variant = 'primary', 
  className = '', 
  as: Component = 'button',
  ...props 
}) {
  const getButtonClasses = () => {
    const baseClasses = {
      'primary': 'sidebar-button primary',
      'secondary': 'sidebar-button secondary',
      'accent': 'sidebar-button accent',
      'save': 'save-button',
      'cancel': 'cancel-button',
      'loading': 'sidebar-button loading',
      'tts': 'tts-button'
    }
    
    return baseClasses[variant] || 'sidebar-button'
  }

  const fullClassName = `${getButtonClasses()} ${className}`.trim()

  return (
    <Component
      className={fullClassName}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </Component>
  )
}

export default Button